import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_SPECIAL_CONSIDERATION_REPORT } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostSpecialConsiderationRequest {
  startDate: string;
  endDate: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSpecialConsiderationReport = ({ onSuccess, onError }: Input = {}) => {
  const PostSpecialConsiderationReport = async (reqBody: PostSpecialConsiderationRequest) => {
    const res = await axiosClient.post(POST_SPECIAL_CONSIDERATION_REPORT, reqBody);
    return res.data;
  };
  return useCustomMutation(PostSpecialConsiderationReport, {
    onSuccess,
    onError,
  });
};
